const Footer = () => (
    <footer className="py-12 md:py-16 px-6 border-t border-slate-200 dark:border-white/5 bg-slate-50 dark:bg-[#030712] transition-colors duration-700">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center">
        <div className="mb-6">
          <h2 className="text-2xl font-black tracking-tighter text-slate-900 dark:text-white uppercase">
            SHUBHAM <span className="text-cyan-500">GHULE</span>
          </h2>
          <p className="text-[10px] uppercase tracking-[0.4em] text-slate-500 dark:text-gray-500 mt-2 font-bold">
            Software Developer
          </p>
        </div>
        <div className="w-12 h-px bg-linear-to-r from-transparent via-cyan-500/50 to-transparent mb-6" />
        <p className="text-[10px] text-slate-400 dark:text-gray-600 font-medium tracking-widest uppercase">
          © {new Date().getFullYear()} • Designing experiences that feel
          effortless.
        </p>
      </div>
    </footer>
  );

export default Footer;
